import { type DiscoverCreateCharacterBlockViewProps } from "@next-platform/client-common-core";
import { Button, ButtonSize, ButtonVariant, Shape, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import DiscoverCreateCharacterArtwork from "@/pages/Discover/components/DiscoverCreateCharacterArtwork";

const DEFAULT_TEST_ID = "DiscoverCreateCharacterBlockView";
const ROOT_CLASS_NAME =
  "grid w-full min-w-0 grid-cols-1 items-center gap-8 overflow-hidden rounded-[22px] border border-[rgba(151,80,221,0.18)] p-8 text-center text-white mob:grid-cols-[320px_1fr] mob:gap-10 mob:p-14 mob:text-left";
const ROOT_STYLE = {
  background: [
    "radial-gradient(60% 60% at 80% 30%, rgba(85,30,140,0.4), transparent 70%)",
    "radial-gradient(50% 50% at 20% 80%, rgba(0,114,245,0.18), transparent 70%)",
    "linear-gradient(180deg, #150522 0%, #050208 100%)",
  ].join(", "),
} as const;
const CONTENT_CLASS_NAME = "flex w-full min-w-0 flex-col items-center gap-4 mob:items-start";
const DESCRIPTION_CLASS_NAME = "max-w-[560px] break-words text-[#AAAAAA]";
const CTA_CLASS_NAME = "bg-white text-black hover:bg-gray-2 dark:bg-white dark:text-gray-1";
const CTA_TEXT_CLASS_NAMES = { text: "text-black dark:text-gray-1" };

type WebDiscoverCreateCharacterBlockViewProps = DiscoverCreateCharacterBlockViewProps & {
  "data-testid"?: string;
};

const DiscoverCreateCharacterBlockView = ({
  title,
  description,
  ctaLabel,
  onPress,
  "data-testid": testId = DEFAULT_TEST_ID,
}: WebDiscoverCreateCharacterBlockViewProps) => {
  const ctaButtonTestId = `${testId}-CtaButton`;

  return (
    <section data-testid={testId} className={ROOT_CLASS_NAME} style={ROOT_STYLE}>
      <DiscoverCreateCharacterArtwork />
      <div className={CONTENT_CLASS_NAME}>
        <Text as="h2" variant={TextVariants.HEADING_2_BOLD} className="my-0 break-words text-white">
          {title}
        </Text>
        <Text variant={TextVariants.PARAGRAPH_MEDIUM_REGULAR} className={DESCRIPTION_CLASS_NAME}>
          {description}
        </Text>
        <Button
          data-testid={ctaButtonTestId}
          type="button"
          variant={ButtonVariant.INVERSE}
          shape={Shape.PILL}
          size={ButtonSize.LARGE}
          className={CTA_CLASS_NAME}
          classNames={CTA_TEXT_CLASS_NAMES}
          onClick={onPress}
        >
          {ctaLabel}
        </Button>
      </div>
    </section>
  );
};

export default React.memo(DiscoverCreateCharacterBlockView);
